<template>
  <div id="signUp">
    <div class="signUp-topbar">
      <i @click="goHome" alt="首页" dir="前往首页"></i>

      <div class="topbar-btn">
        <div class="changeLangBtn" @click.stop="moreLang()">
          <button class="text">
            {{ $t("language") }}
          </button>
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              <button class="text">
              {{ item.name }}
              </button>
            </li>
          </ul>
        </div>

        <div class="toLogin btn" @click.stop="goLogin()">
          <button class="text">
            {{ $t("homepage_button1") }}
          </button>
        </div>
      </div>
    </div>

    <div class="signUp-wrapper">
      <div class="signUp">
        <div class="signUp-title">
          {{ $t("signup_title") }}
        </div>

        <div class="inputItem firstName">
          <span class="account">{{ $t("signup_txt2") }}</span>
          <input
            type="text"
            v-model.trim="signUpForm.name"
            @blur="checkName"
            @focus="checkName1"
          />
          <span class="input-warning" v-show="show2">
            {{ $t("signup_note8") }}
          </span>
        </div>

        <div class="inputItem grade">
          <span class="account">{{ $t("signup_txt3") }}</span>
          <div class="classGrade">
            <select v-model="signUpForm.grade" @change="checkGrade">
              <option value="" style="display: none">
                {{ $t("signup_note9") }}
              </option>
              <option value="0">{{ $t("grade0") }}</option>
              <option value="1">{{ $t("grade1") }}</option>
              <option value="2">{{ $t("grade2") }}</option>
              <option value="3">{{ $t("grade3") }}</option>
              <option value="4">{{ $t("grade4") }}</option>
              <option value="5">{{ $t("grade5") }}</option>
              <option value="6">{{ $t("grade6") }}</option>
              <option value="7">{{ $t("grade7") }}</option>
              <option value="8">{{ $t("grade8") }}</option>
              <option value="9">{{ $t("grade9") }}</option>
              <option value="10">{{ $t("grade10") }}</option>
              <option value="11">{{ $t("grade11") }}</option>
              <option value="12">{{ $t("grade12") }}</option>
              <option value="13">{{ $t("grade13") }}</option>
            </select>
          </div>
          <span v-show="show9" class="input-warning">
            {{ $t("signup_note10") }}
          </span>
        </div>

        <div class="inputItem schoolName">
          <span class="account" style="z-index: 900">
            {{ $t("schoolName") }}
          </span>
          <el-autocomplete
            class="school_name"
            v-model="signUpForm.schoolCnName"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            :placeholder="country == 'china' ? '请输入' : ' '"
            value-key="schoolCnName"
            @select="changeSchool"
          ></el-autocomplete>
        </div>

        <div class="inputItem phone">
          <span
            class="account"
            v-if="$i18n.locale == 'zh'"
          >
            {{ $t("signup_txt9") }}
          </span>
          <span class="account" v-else>
            {{ $t("myaccount_txt5") }}
          </span>
          <input
            v-model.trim="signUpForm.phone"
            type="text"
            dir="ltr"
            @blur="checkphone"
            @focus="checkphone1"
          />
          <span v-show="show6" v-text="phoneText" class="input-warning">
            {{ $t("signup_note14") }}
          </span>
        </div>

        <div class="inputItem phoneAuth">
          <span class="account">{{ $t("signup_txt10") }}</span>

          <input
            type="text"
            v-model.trim="signUpForm.phoneCode"
            style="padding-right: 118px; width: 203px"
            @blur="checkphoneCode"
            @focus="checkphoneCode1"
          />

          <button id="buttonMsg" @click="getMsg" v-text="getMsgtext"></button>

          <span v-show="show7" class="input-warning">
            {{ $t("signup_note15") }}
          </span>
        </div>

        <div class="inputItem password">
          <span class="account">{{ $t("signin_txt2") }}</span>
          <input
            v-model.trim="signUpForm.password"
            autocomplete="off"
            dir="ltr"
            :type="passwordSwitch === false ? 'password' : 'text'"
            @blur="checkpwd"
            @focus="checkpwd1"
          />
          <span @click="showPwdSwitch" class="pwdSwitch">
            <i class="el-icon-view"></i>
          </span>

          <span v-show="show4" class="input-warning">
            {{ $t("setPass_txt2") }}
          </span>
        </div>

        <button class="signUp-btn" @click="submit">
          {{ $t("signup_button") }}
        </button>

        <span class="signUp-warning" v-text="warining" v-show="show11">
          {{ $t("signup_note16") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {
    return {
      changeLangBox: false,  // 语言下拉窗口显示

      phoneText: "",
      registerChannel: "",
      show2: false,
      show2Reg: false,
      show3: false,
      show3Reg: false,
      show4: false,
      show4Reg: false,
      show5: false,
      show5Reg: false,
      show6: false,
      show6Reg: false,
      show7: false,
      show7Reg: false,
      show8: false,
      show8Reg: false,
      show9: false,
      show9Reg: false,
      show11: false,
      zhShow: false,
      passwordSwitch: false,
      getMsgtext: "",
      warining: "",

      signUpForm: {             // 填写的表格信息
        name: "",
        grade: "",
        schoolCnName: "",
        email: "",
        phone: "",
        phoneCode: "",
        password: "",
      },

      langList: I18nUtils.langList,

      maskShow: true,
      country: "",  // 服务器所在的国家
      channel: "",
    };
  },

  methods: {
    // 检查姓名 - 名
    checkName() {
      this.show11 = false;

      if (this.signUpForm.name != "") {
        this.show2 = false;
        this.show2Reg = true;
      } else {
        this.show2 = true;
        this.show2Reg = false;
      }
    },
    checkName1() {
      this.show2 = true;
      this.show11 = false;
    },
    showPwdSwitch() {
      this.passwordSwitch = !this.passwordSwitch;
    },
    // 检查年级
    checkGrade() {
      this.show11 = false;
      this.show9 = false;
    },

    // 按输入的关键词搜索学校
    querySearchAsync(queryString, cb) {
      if (queryString == null || queryString == "") {
        cb([]);
        return;
      }
      this.$http
        .getAxios("/mobile/querySchoolMsg?schoolName=" + queryString, {
          method: "post",
        })
        .then((res) => {
          var res = res.data;

          if (res.code == "0") {
            var schools = res.data;
            if (schools == null) {
              console.log("empty school first school");
              // 延迟1s 提示 新学校注册
              // setTimeout(() => {
              //   this.$notify.success({
              //     title: "WOW！你是该学校第一个注册的用户哦！",
              //     message:
              //       "当您注册成功后，我们将收录您的学校，以后别人就可以在学校列表中找到它啦！",
              //     // 提示不会自动关闭并显示6s后自动关闭
              //     duration: 5000,
              //   });
              // }, 1000);
              cb([]);
              return;
            }
            var results = queryString
              ? schools.filter(this.createStateFilter(queryString))
              : schools;
            console.log("results", results);
            cb(results);
          } else {
            cb([]);
          }
        });
    },
    // 学校名字过滤并替换
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.schoolCnName.toLowerCase().indexOf(queryString.toLowerCase()) >=
          0
        );
      };
    },
    // 学校名字替换
    changeSchool(e) {
      this.signUpForm.schoolCnName = e.schoolCnName;
    },

    // 检查password
    checkpwd() {
      let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/;
      this.show11 = false;

      if (reg.test(this.signUpForm.password)) {
        this.show4 = false;
        this.show4Reg = true;
      } else {
        this.show4 = true;
        this.show4Reg = false;
      }
    },
    checkpwd1() {
      this.show4 = true;
      this.show11 = false;
    },

    // 检查 phone输入 和 email输入
    checkphone() {
      // 号码或者邮箱
      if (this.$i18n.locale != 'zh') { // 非中国地区可以用邮箱注册
        
        this.show11 = false;
        let regs = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
        if (regs.test(this.signUpForm.phone)) {
          this.show6 = false;
          this.show6Reg = true;
          this.phoneText = this.$t("signup_note14");
        } else {
          if (this.signUpForm.phone == "") {
            this.phoneText = this.$t("signup_note14");
          } else {
            this.phoneText = this.$t("signup_note4");
          }
          this.show6 = true;
          this.show6Reg = false;
        }
      } else {
        // 其他
        this.show11 = false;
        let regs = /^1[123456789]\d{9}$/;
        if (regs.test(this.signUpForm.phone)) {
          this.show6 = false;
          this.show6Reg = true;

          // 请输入您的手机号
          this.phoneText = this.$t("signup_note14");
        } else {
          if (this.signUpForm.phone == "") {
            // 请输入您的手机号
            this.phoneText = this.$t("signup_note14");
          } else {
            // 无效手机号
            this.phoneText = this.$t("signup_note4");
          }
          this.show6 = true;
          this.show6Reg = false;
        }
      }
    },
    checkphone1() {
      this.show11 = false;
      this.show6 = true;
      this.phoneText = this.$t("signup_note14");
    },

    // 检查验证码
    checkphoneCode() {
      let reg = /^[0-9]{6}$/;
      this.show11 = false;

      if (reg.test(this.signUpForm.phoneCode)) {
        this.show7 = false;
        this.show7Reg = true;
      } else {
        this.show7 = true;
        this.show7Reg = false;
      }
    },
    checkphoneCode1() {
      this.show7 = true;
      this.show11 = false;
    },

    // 点击验证码按钮功能
    getMsg() {
      try {
        if (this.signUpForm.phone != "" && this.show6Reg) {
          switch (this.$i18n.locale) {
            // 以色列用户
            case "en":
            case "he":
               {
              this.$http
                .getAxios("/sms/sendMsg", {
                  method: "post",
                  data: {
                    account: this.signUpForm.phone,
                    type: 1,
                  },
                })
                .then((res) => {
                  if (res.data.code == "0") {
                    this.$message.success({
                      message: this.$i18n.t("The verification code has been sent"),
                      duration: 4000,
                    });
                    this.start_sms();
                  } else if (res.data.code == "41") {
                    this.$message.error({
                      message: this.$i18n.t("signup_fail2"),
                      duration: 4000,
                    });                  
                  } else {
                    this.show11 = true;
                    this.warining = res.msg;
                  }
                });
              break;
            }
            // 默认用户
            default: {
              this.$http
                .getAxios("/mobile/sendMsg", {
                  method: "post",
                  data: {
                    account: this.signUpForm.phone,
                  },
                })
                .then((res) => {
                  if (res.data.code == "0") {
                    this.$message.success("验证码发送成功！");
                    this.start_sms();
                  } else {
                    this.show11 = true;
                    this.warining = res.msg;
                    this.$message.error({
                      message:
                        "发生错误。原因:" +
                        res.data.msg +
                        "错误码：" +
                        res.data.code,
                    });
                  }
                });
              break;
            }
          }
        } else {
          if (this.country == "china") {
            this.$message.error("请输入手机号!");
          } else {
            this.$message.error(
              "Please enter all relevant information correctly !"
            );
          }
        }
      } catch (error) {
        console.log("getMsg error", error);
      }
    },

    // 发送验证码后倒计时读秒
    start_sms() {
      var count = 1;
      var sum = 60;
      var that = this;
      /**
       * 发送验证码成功后，
       * 开始将文字变为60s，
       * 然后进行倒计时至1.
       */
      var i = setInterval(function() {
        if (count > 60) {
          document.getElementById("buttonMsg").removeAttribute("disabled");
          document.getElementById("buttonMsg").style.cursor = "pointer";

          that.getMsgtext = that.$t("signup_txt11");

          clearInterval(i);
        } else {
          document.getElementById("buttonMsg").setAttribute("disabled", true);
          document.getElementById("buttonMsg").style.cursor = "not-allowed";
          that.getMsgtext = parseInt(sum - count) + "s";
        }
        count++;
      }, 1000);

      /**
       * 路由跳转后，立即销毁计时器
       * 否则会不停地在控制台报错计时器问题
       */
      this.$once("hook:beforeDestroy", () => {
        clearInterval(i);
        console.log("clear!");
      });
    },

    // 点击注册按钮事件
    submit() {
      if (this.signUpForm.grade == "") {
        this.show9 = true;
        this.warining = this.$t("signup_note17");
        this.show11 = true;
        return;
      }

      if (
        this.$i18n.locale == "en" ||
        this.$i18n.locale == "sp" ||
        this.$i18n.locale == "fr"
      ) {
        this.show6Reg = true;
        this.show7Reg = true;
      }

      if (
        this.show2Reg &&
        this.show4Reg &&
        this.show6Reg &&
        this.show7Reg &&
        this.signUpForm.schoolName != ""
      ) {
        this.show11 = false;
        this.warining = "";

        if (this.$i18n.locale != "zh") {  // 使用邮箱注册
          this.$http
            .getAxios("/sms/userRegister", {
              method: "post",
              data: {
                firstName: this.signUpForm.name,
                grade: this.signUpForm.grade,
                schoolCnName: this.signUpForm.schoolCnName,
                password: md5(this.signUpForm.password),
                email: this.signUpForm.phone,
                verifyCode: this.signUpForm.phoneCode,
                userArea: 5,
              },
            })
            .then((res) => {
              var res = res.data;
              /**
               * 41: 用户已存在 USER_EXIST = 41;
               * 9： 验证码错误 VERIFYCODE_ERR = 9;
               * 10 验证码超时 VERIFYCODE_OVER_TIME = 10;
               */
              if (res.code == "0") {
                this.$message.success({
                  message: this.$i18n.t("Registered_successfully"),
                });
                this.$router.push({ path: "/signIn" });
              } else if (res.code == "41") {
                this.$message.error({
                  message: this.$i18n.t("The email registerd"),
                });
              } else if (res.code == "10" || res.code == "9") {
                this.$message.error({
                  message: this.$i18n.t("signup_note5"),
                });
              } else {
                this.show11 = true;
                this.warining = res.msg;
              }
            });
        } else {    // 手机注册
          this.$http
            .getAxios("/mobile/studentSignUp", {
              method: "post",
              data: {
                firstName: this.signUpForm.name,
                grade: this.signUpForm.grade,
                schoolCnName: this.signUpForm.schoolCnName,
                password: md5(this.signUpForm.password),
                mobile: this.signUpForm.phone,
                verifyCode: this.signUpForm.phoneCode,
                c: this.registerChannel,
              },
            })
            .then((res) => {
              var res = res.data;
              if (res.code == "0") {
                this.$message.success(this.$t("Registered_successfully"));

                if (this.channel == "") {
                  this.$router.push({ path: "/signIn" });
                } else {
                  window.location.href = "https://c.icode.org.cn/" + this.channel;
                }
              } else if (res.code == "41") {
                this.$message.success("该手机号已经注册，请登录。");
                this.$router.push({ path: "/signIn" });
              } else {
                this.show11 = true;
                this.warining = res.msg;
              }
            });
        }
      } else {
        this.show11 = true;
        this.warining = this.$t("signup_note17");
      }
    },

    // nav栏控件
    goLogin() {
      this.$router.push({ path: "/signIn" });
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    // 打开语言选择按钮
    moreLang() {
      this.changeLangBox = !this.changeLangBox;
    },

    // 改变语言
    setLanguage(lang) {
      this.warining = "";
      // // 重置signUpForm表单
      // this.signUpForm = {
      //   name: "",
      //   grade: "",
      //   schoolCnName: "",
      //   phone: "",
      //   phoneCode: "",
      //   password: "",
      // };
      // this.signUpForm

      I18nUtils.setLanguage(this, lang);
      this.getMsgtext = this.$t("signup_txt11"); // 发送按钮为动态显示

    },

    checkChannel() {
      let args = {};
      const qs =
        window.location.search.length > 0
          ? window.location.search.substr(1)
          : "";

      const itemsArray = qs.length > 0 ? qs.split("&") : [];

      itemsArray.forEach((el) => {
        let item = el.split("=");
        let name = decodeURIComponent(item[0]);
        let value = decodeURIComponent(item[1]);

        if (name.length !== 0) {
          args[name] = value;

          // 操作1
          if (name == "channel") {
            this.channel = value;
          }
          // 添加注册页面访问记录
          if (name == "c") {
            this.registerChannel = value;
            if (value != "") {
              this.$http.getAxios.get("/discovery/log", {
                params: {
                  c: value,
                },
              });
            }
          }
        }
        // console.log(args);
        return args;
      });
    },
  },

  mounted() {
    // I18nUtils.initLanguage(this);
    I18nUtils.initLanguage(this);

    // init
    this.getMsgtext = this.$t("signup_txt11");
    this.phoneText = this.$t("signup_note14");

    this.checkChannel();
  },
};
</script>

<style lang="scss">
#signUp {
  .signUp-topbar {
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;

    i {
      position: absolute;
      top: 7px;
      left: 30px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      background: url("~@/assets/images/bigIcon.png") no-repeat center;
    }

    .topbar-btn {
      position: absolute;
      height: 60px;
      top: 0;
      right: 40px;
      z-index: 323;

      .btn {
        transition: color 0.3s ease-in-out;

        &:hover {
          color: #31c6d1;
        }
      }

      .changeLangBtn {
        float: right;
        min-width: 80px;
        line-height: 60px;
        font-size: 18px;
        font-weight: normal;
        text-align: center;
        cursor: pointer;

        span {
          padding: 17px 0;
        }
        em {
          margin-left: 5px;
        }

        .chooseLangUl {
          position: absolute;
          z-index: 111;

          li {
            min-width: 80px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .toLogin {
        float: right;
        margin-right: 30px;
        font-size: 18px;
        line-height: 60px;
        cursor: pointer;
      }
    }
  }

  .signUp-wrapper {
    display: flex;
    min-height: 100vh;
    justify-content: center;
    align-items: center;

    .signUp {
      text-align: center;

      .signUp-title {
        width: 100%;
        height: 58px;
        line-height: 55px;
        font-size: 38px;
        font-weight: 700;
        color: #37c2e5;
        background: url("~@/assets/images/title.png") no-repeat center;
      }

      .inputItem {
        margin-top: 40px;
        position: relative;
        margin-bottom: 34px;

        .pwdSwitch {
          position: absolute;
          right: 20px;
          top: 20px;
          width: 20px;
          height: 20px;
        }

        .account {
          position: absolute;
          top: 11px;
          left: 17px;
          width: 142px;
          height: 33px;
          line-height: 33px;
          font-size: 16px;
          color: #010101;
          border-right: 1px solid #999999;
        }

        // 年级 和  学校名 是特殊的两组布局
        .classGrade {
          padding-left: 170px;
          height: 56px;
          line-height: 56px;
          font-size: 16px;
          border-radius: 8px;
          background-color: #ffffff;

          select {
            width: 100%;
            height: 100%;
            outline: none;
            border: none;
            border-radius: 8px;
          }
        }

        .school_name {
          padding-left: 170px;
          width: 320px;
          font-size: 16px;
          border: 0;
          border-radius: 8px;
          background-color: #ffffff;

          .el-input {
            .el-input__inner {
              padding: 0;
              font-size: 14px;
              box-shadow: unset;
            }
          }
        }

        .input-warning {
          position: absolute;
          left: 20px;
          bottom: -26px;
          font-size: 14px;
          color: red;
        }

        .verifyCodeBtn-send {
          opacity: 0.7;
          cursor: not-allowed;
        }

        button {
          position: absolute;
          top: 20px;
          right: 30px;
          font-size: 16px;
          color: #173ebf;
          cursor: pointer;
          border: none;
          outline: none;
          margin: 0;
          padding: 0;
          background-color: transparent;
        }

        input {
          padding-left: 170px;
          width: 320px;
          height: 56px;
          line-height: 56px;
          font-size: 16px;
          border: 0;
          border-radius: 8px;
          background-color: #ffffff;
          box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
        }

        ::-webkit-input-placeholder {
          color: #999999;
        }
        :-moz-placeholder {
          color: #999999;
        }
        :-ms-input-placeholder {
          color: #999999;
        }
      }

      .signUp-btn {
        width: 461px;
        height: 59px;
        background-color: #2d8c9e;
        border-radius: 29px;
        color: #fff;
        margin: 0 auto;
        border: 0;
        display: block;
        font-size: 20px;
        cursor: pointer;
      }

      .signUp-warning {
        margin-top: 20px;
        display: block;
        color: red;
        font-size: 18px;
      }
    }
  }


button:active{
    position: relative;
    top: 4px;
    box-shadow: inset 0 3px 5px 0 rgba(0,0,0,0.2);  
    outline: 0;
}
button:focus, button:hover {
  box-shadow: inset 0 -1px 0 0 #aaf9fe, 0 0 2px 0 cyan;
}

button.text {
  border: none;
  background: none;
  cursor: pointer;
  color: #aaf9fe;
  padding: 2px;
}

button.underline {
  text-decoration: underline;
}

input {
  text-indent: 10px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/signUp.vue